import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import "./style.css";

interface Project {
  id: string;
  title: string;
  description: string;
  pdf_url: string;
  banner_image?: string;   // ✅ new (optional)
  youtube_id?: string;     // ✅ new (optional, already normalized by admin)
}

export function ProiectePage() {
  const [headerImage, setHeaderImage] = useState("");
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "projects_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data() as {
          header_image?: string;
          projects?: Project[];
        };
        setHeaderImage(data.header_image || "");
        setProjects(data.projects || []);
      }
    };
    fetchData();
  }, []);

  const youtubeEmbedUrl = (id?: string) =>
    id ? `https://www.youtube.com/embed/${id}` : "";

  return (
    <div className="page-container">
      <Navbar />

      {headerImage && (
        <div
          className="projects-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}

      <div className="page-content projects-page">

        <div className="project-list">
          {projects.map((proj) => (
            <article key={proj.id} className="project-item">
              {/* Banner specific proiect (opțional) */}
              {proj.banner_image ? (
                <div
                  className="project-cover"
                  style={{ backgroundImage: `url(${proj.banner_image})` }}
                  aria-label={`Banner proiect ${proj.title}`}
                />
              ) : null}

              <div className="project-body">
                <h3>{proj.title}</h3>
                <p>{proj.description}</p>

                {/* Video YouTube (opțional) */}
                {proj.youtube_id ? (
                  <div className="project-video">
                    <div className="yt-embed">
                      <iframe
                        src={youtubeEmbedUrl(proj.youtube_id)}
                        title={`Video ${proj.title}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        loading="lazy"
                      />
                    </div>
                  </div>
                ) : null}

                <a
                  className="btn btn-ghost"
                  href={proj.pdf_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Descarcă PDF
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}